import { create } from "zustand";

const MINIMAL_LOADING_DURATION = 100;

interface LoaderStore {
  increase: (by: number) => void;

  isLoading: () => boolean;
  requests: number;

  isLoadingByModal: () => boolean;
  modalRequests: number;

  isLoadingBySkeleton: () => boolean;
  skeletonRequests: number;
}

export enum ELoadingOptions {
  MODAL = "MODAL",
  SKELETON = "SKELETON",
  NONE = "",
}

export const useLoaderStore = create<LoaderStore>()((set, get) => ({
  increase: (by) => set((state) => ({ requests: state.requests + by })),

  isLoading: () => get().requests > 0,
  requests: 0,

  isLoadingByModal: () => get().modalRequests > 0,
  modalRequests: 0,

  isLoadingBySkeleton: () => get().skeletonRequests > 0,
  skeletonRequests: 0,
}));

const updateRequests = (
  by: number,
  type: "requests" | "modalRequests" | "skeletonRequests",
) => {
  useLoaderStore.setState((state) => ({
    [type]: state[type] + by,
  }));
};

const handleLoader = (by: number, loadingType: ELoadingOptions) => {
  if (loadingType === ELoadingOptions.NONE) return;

  updateRequests(by, "requests");

  if (loadingType === ELoadingOptions.MODAL) {
    updateRequests(by, "modalRequests");
  } else if (loadingType === ELoadingOptions.SKELETON) {
    updateRequests(by, "skeletonRequests");
  }
};

export const setLoader = (
  loadingType: ELoadingOptions = ELoadingOptions.NONE,
) => {
  handleLoader(1, loadingType);
  if (loadingType === ELoadingOptions.MODAL) {
    handleLoader(1, ELoadingOptions.SKELETON);
  }
};

export const removeLoader = (
  loadingType: ELoadingOptions = ELoadingOptions.NONE,
) => {
  setTimeout(() => {
    handleLoader(-1, loadingType);
    if (loadingType === ELoadingOptions.MODAL) {
      handleLoader(-1, ELoadingOptions.SKELETON);
    }
  }, MINIMAL_LOADING_DURATION);
};
